<template>

    <TheNavbarComponent />

    <section id="home">

        <TheHomeComponent />

    </section>

    <div class="container mb-5">

        <section id="about" class="pt-5">

            <TheAboutMeComponent />

        </section>

        <hr class="my-5">

        <section id="services">

            <TheServiceComponent />

        </section>

        <hr class="my-5">

        <section id="contact">

            <TheContactComponent />

        </section>

        <hr class="my-5">

    </div>

    <TheFooterComponent />

</template>

<script>

    import TheNavbarComponent from '@/components/TheNavbarComponent'
    import TheHomeComponent from '@/components/TheHomeComponent'
    import TheAboutMeComponent from '@/components/TheAboutMeComponent'
    import TheServiceComponent from '@/components/TheServiceComponent'
    import TheContactComponent from '@/components/TheContactComponent'
    import TheFooterComponent from '@/components/TheFooterComponent'

    export default {

        name: 'TheMainLayout',

        components: {

            TheNavbarComponent,
            TheHomeComponent,
            TheAboutMeComponent,
            TheServiceComponent,
            TheContactComponent,
            TheFooterComponent,

        },

    }

</script>

<style scoped>

</style>
